export const CAMPAIGN_TYPES_ALLOWED_COMPANIES = [
  'a26af570-3916-4120-8371-6c3f816db0bf', // V4
  '97b5e82d-4d9a-4154-8a4d-dc0d907b5375', // GHFLY
  'b5fb587a-236d-4f13-9403-8eab52bf2e68', // 5àsec
  '3f527d26-d45e-46cf-91c2-b0039442266e', // Accor
  'a718bada-6955-431b-99bd-37190626da71', // Adsplay
  '6494e541-cf8f-4847-8d17-ff1efe250df2', // Pixel Roads
  '9887a340-59b2-4862-9e4f-86e1daf4bbfe', // Equipe Pixel Roads
  'b22bb839-1bad-498a-b951-658daaee2860', // Korttega Digital
  '3f0c67e7-ae1a-467b-8fd9-7e589f717a53' // MSA RH
]
